import React from 'react';
import { HeaderH1, Paragraph } from './Styling/GlobalStyle'

export const Header = () => {
  return (
    <div>
      <HeaderH1>Get it done...</HeaderH1>
      <Paragraph>
        Need to remember what do to next? <br />
      </Paragraph>
    </div>
  );
}
